<template>
  <div class="container">
    <van-loading type="spinner" color="#1989fa" vertical>加载中</van-loading>
    <van-popup v-model="isTipsPop" round :close-on-click-overlay="false">
      <div class="box">
        <div class="box-title">{{ tipsInfo.H5_TIPS }}</div>
        <van-field v-model="order" label="口令" placeholder="请输入口令" />
        <div class="btn-box" @click="submit">确定</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { redirecToWx } from '@/utils/login'
import { appId } from '@/utils/constant'
import { getToken, setToken } from '@/utils/auth'
import { getUrlParam,isInWX, isInApp, isAndroid, isIOS } from '@/utils/utils'
import { getTokenFromApp } from '@/utils/native-funs'
import IosBridge from '@/utils/ios-bridge'
import store from "@/store";
export default {
  name: 'InitPage',
  data() {
    return {
      order: '',
      isTipsPop: false,
      tipsInfo: {}
    }
  },
  methods: {
    async init() {
      if (process.env.BUILD_ENV === 'dev') {
        this.redirect();
        return;
      }
      if (isInWX()) {
        this.initInWX();
      } else {
        const token = await getTokenFromApp()
        this.$cache.setIs365();
        this.setCache(token)
      }
    },
    async initInWX() {
      // 获取code 进行登录
      const code = this.getCodeFromUrl();
      if (!code) {
        return;
      }
      this.setCache(code);
    },
    // 从微信获取code后，从URL上获取code
    getCodeFromUrl() {
      // url无code，跳转微信授权
      const code = getUrlParam('code');
      const lastCode = this.$cache.getUsedWxCode();
      if (!code || code === lastCode) {
        redirecToWx(appId);
        return;
      }
      this.$cache.setUsedWxCode(code);
      return code;
    },
    async setCache(code) {
      let parmes = isInWX() ? {code: code}: {token: code}
      const {data, message} = await this.$api.common.login(parmes).catch(err => err);
      if (!data || !data.gwToken) {
        let msg = message || '获取token失败，请关闭后重试';
        this.$dialog.alert({
          message: msg
        });
        return;
      }
     
     
      this.$cache.setLoginInfo(data);
      let isBinding = isInWX() ? data.bound : data.xcxBound
      this.$cache.setBindingState(isBinding);
      if (!isInWX() && !isBinding) {
        this.$cache.setWxBinDing(false)
        this.$router.push({
          path: '/applet-login'
        })
        return
      } 
      setToken(data.gwToken);
      if (!isBinding) {
        this.$router.replace({
          path: '/binding'
        })
        return
      }

      const res = await this.$api.common.getLoginUserList({telephoneMd5: data.telephoneMd5})
      this.$cache.setLoginUserList(res.data || [])
      if (res.data.length == 1) {
        this.btnLogin({id: res.data[0].id, wxToken: data.wxToken})
      } else {
        this.$router.replace({ path: '/role-change' });
      }
      // 获取部门
      // const res = await this.$api.h5.userSaleShopInfo()
      // this.$cache.setLoginDepartment(res.data || [])
      // if ((data.users && data.users.length) || (res.data && res.data.length)) {
      //   this.$router.replace({ path: '/role-change' });
      // }else {
      //   this.redirect();
      // }
    },
    // async initIn365() {
    //   this.getTokenInApp().then((token) => {
    //     this.$cache.setIs365();
    //     this.setCache(token)
    //   }).catch(errMsg => {
    //     this.$dialog.alert({
    //       message: errMsg
    //     });
    //   });
    // },
    // getTokenInApp() {
    //   let errMsg = '获取token失败，请重试'
    //   return new Promise((resolve, reject) => {
    //     if (isAndroid()) {
    //       const token = window.android.token();
    //       if (!token) {
    //         reject(errMsg);
    //       } else {
    //         resolve(token);
    //       }
    //     } else if (isIOS()) {
    //       IosBridge.callhandler('iosToken', null, token => {
    //         if (!token) {
    //           reject(errMsg);
    //         } else {
    //           resolve(token);
    //         }
    //       });
    //     } else {
    //       reject('异常设备，请联系管理员');
    //     }
    //   });
    // },
    btnLogin(item) {
      let parmes = {
        userId: item.id,
        wxToken: item.wxToken,
        flag: this.$cache.is365() ? 2 : 1
      };
      this.$api.common.confirmLoginUser(parmes)
        .then(async _ => {
          // 获取部门
          const res = await this.$api.h5.userSaleShopInfo()
          if (res.data.length > 1) {
            this.$router.replace({ path: '/role-change' });
          } else {
            await store.dispatch("getUserInfo");
            this.redirect();
          }
        })
    },
    // 根据参数进行页面跳转
    redirect() {
      this.$router.replace({ path: '/home'});
    },
    submit() {
      if (this.order === this.tipsInfo.H5_WORD_COMM) {
        this.isTipsPop = false
        this.initRequest()
      }else {
        this.$toast('指令错误请重新输入')
      }
    },
    initRequest() {
      if (!this.isTipsPop) {
        if(!getToken()) {
          this.init();
        }else{
          this.redirect();
        }
      }
    }
  },
  mounted() {
    this.$api.h5.queryPublicityData('SYS_UPGRADE').then(res => {
      if (res.success && res.data) {
        this.tipsInfo = res.data
        this.isTipsPop = res.data.H5_OPEN_CONFIG == 1 ? true : false
        if (!this.isTipsPop) {
          this.initRequest()
        }
      } else {
        this.initRequest()
      }
    }).catch(err => {
      this.initRequest()
    })
    
  }
}
</script>

<style lang="stylus" scoped>
.container
  text-align center
  height 100vh
  display flex
  flex-direction column
  justify-content center
  align-items center
  .box {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 300px;
    height: 200px;
    .box-title {
      text-align: center;
      padding: 10px;
      font-weight: bold;
    }
    .btn-box {
      width: 260px;
      height: 36px;
      color: #fff;
      font-weight: bold;
      text-align: center;
      line-height: 36px;
      margin-top: 60px;
      background: linear-gradient(180deg, #FF8820 0%, #FF6B31 100%);
      border-radius: 25px;
    }
  }
</style>
